import { CommApiInstance } from "Utils/CommApiInstance";

export interface CommuBrdPstdCtntApiResponse {
    apiHdr: {
        code: string;
        msg: string;
        respDtime: string;
        rqstTrxId: string;
        rqstDtime: string;
        lang: string;
        timeZone: string;
    };
    apiBody: {
        brdPstdTitl: string;
        brdPstdCtxt: string;
        brdPstdReadCnt: number;
        crtdDtime: string;
        nickname: string;
        membRcmnCd: string;
        mineYn: string;
        prevBrdPstdSno: number;
        prevBrdPstdTitl: string | null;
        nextBrdPstdSno: number;
        nextBrdPstdTitl: string | null;
    };
}

const CommuBrdPstdCtntApi = async (
    brdCd:string,
    brdPstdSno:string,
    brdCtgrCd:string,
) : Promise<CommuBrdPstdCtntApiResponse> => {
    return await CommApiInstance.post(`brd/KRBBO/${brdCd}/${brdPstdSno}?brdCtgrCd=${brdCtgrCd}`,{
        apiBody:{
        }
    })
    .then((Resp) => Resp.data as CommuBrdPstdCtntApiResponse);
}
export default CommuBrdPstdCtntApi;